export default __webpack_public_path__ + "static/media/einzig_wahre_portrait.b532a0e6.jpg";